import React from 'react'
import asideModalStore from 'Stores/asideModalStore'
import st from './AddEvaluationCriteriaModal.module.scss'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import { observer } from 'mobx-react'
import SelectCustom from '../../../Global/Select/SelectCustom'
import DummyCounter from '../../../Global/Counter/DummyCounter'

const AddEvaluationCriteriaModal = ({ translate }) => {
  const { modalValues: modalValue, changeValue, check } = asideModalStore

  return (
    <div className={st.fieldSet}>
      <div className={st.flex}>
        <FormField>
          <FormLabel isRequired>{translate.name}:</FormLabel>
          <FormInput isError={check('name')}>
            <input
              type='text'
              placeholder={translate.name}
              name='name'
              value={modalValue?.name || ''}
              onChange={(e) => changeValue(e.target.value, 'name')}
            />
          </FormInput>
        </FormField>
        <FormField>
          <FormLabel isRequired>{translate.serial_number}:</FormLabel>
          <DummyCounter
            value={modalValue.order || 0}
            min={0}
            max={1000}
            name='order'
            step={1}
            onChange={(e) => changeValue(e, 'order')}
            isError={check('order')}
          />
        </FormField>
      </div>
      <FormField>
        <FormLabel isRequired>{translate.company}:</FormLabel>
        <SelectCustom
          placeholder={translate.company}
          apiLink='db/companies'
          valueID={modalValue.company}
          onChange={(o) => changeValue(o.id, 'company')}
          error={check('company')}
        />
      </FormField>
    </div>
  )
}

export default observer(AddEvaluationCriteriaModal)
